module.exports = __webpack_public_path__ + "static/media/recycle_bin.a2ca973b.svg";